import React from 'react';
import './BookingCalendar.css';

const BookingCalendar = ({ children, visible = true }) => {
  if (!visible) {
    return null;
  }

  return <div className="booking-calendar-shell">{children}</div>;
};

export default BookingCalendar;
